import store from 'app/store';
import { CustomerStructureType } from 'data/types';
import {
  setShouldArrangeSpaces,
  setShouldAutoGenerateLevels,
  setShouldAutoGenerateSpaces
} from 'features/ai/ai-slice';
import { runWithoutStructureHistory } from 'features/structure/structure-history-middleware';
import {
  setStructure,
  setSuggestedSpaces
} from 'features/structure/structure-slice';
import {
  getAssignedImageForLevel,
  restoreStructureAttributes,
  revalidateStructureSizingAttributes
} from 'utils/structure';

export function applyLoadedStructureLevels(
  structure: CustomerStructureType
): void {
  const levels = structure.levels ?? [];
  runWithoutStructureHistory(() => {
    store.dispatch(
      setStructure(
        revalidateStructureSizingAttributes(restoreStructureAttributes(levels))
      )
    );
  });

  const {
    structure: loadedStructure,
    structureAttachments: loadedAttachments,
    structureImageAssignments: loadedImageAssignments
  } = store.getState().structure;
  loadedStructure.forEach((level) => {
    if (!level.suggestedSpaces || level.suggestedSpaces.length === 0) return;
    const hasAssignedImage = !!getAssignedImageForLevel(
      level.uniqueId,
      loadedImageAssignments,
      loadedAttachments
    );
    if (!hasAssignedImage) {
      store.dispatch(
        setSuggestedSpaces({
          levelUniqueId: level.uniqueId,
          suggestedSpaces: []
        })
      );
    }
  });
}

export function applyLoadedStructureGenerationFlags(
  structure: CustomerStructureType
): void {
  const levels = structure.levels ?? [];
  const hasLevels = levels.length > 0;
  const hasSpaces = levels.some((level) =>
    level.sections?.some((section) => section.spaces?.length > 0)
  );
  const hasStructureImages =
    store.getState().structure.structureAttachments.length > 0;
  const { preventAutoGenerateSpaces } = store.getState().ai;

  store.dispatch(setShouldAutoGenerateLevels(!hasLevels));
  store.dispatch(
    setShouldAutoGenerateSpaces(
      !preventAutoGenerateSpaces && hasLevels && !hasSpaces
    )
  );
  store.dispatch(setShouldArrangeSpaces(hasSpaces && hasStructureImages));
}
